// src/components/store/sections/faqs/FaqV97CyberterminalCrimsonRose.tsx
"use client";

import React from "react";
import DynamicFaqVariant from "./DynamicFaqVariant";

export default function FaqV97CyberterminalCrimsonRose(props: any) {
  return (
    <DynamicFaqVariant
      variantNumber={97}
      archKey="cyber_terminal"
      archLabel="Cyber Terminal Help"
      palName="CrimsonRose"
      grad="from-rose-500 via-pink-600 to-red-600"
      lightBg="bg-rose-50"
      textCol="text-rose-700"
      borderCol="border-rose-200"
      btnCls="bg-rose-600 hover:bg-rose-700"
      hexCol="#f43f5e"
      {...props}
    />
  );
}
